export enum NotifyStatuses {
    new = 'new',
    read = 'read',
}

export enum NotifySortField {
    datetimeAsc = 'datetime-asc',
    datetimeDesc = 'datetime-desc',
}

export enum NotifyMenuActions {
    markAllRead = 'markAllRead',
    openNotifyTable = 'openNotifyTable',
}
